import React, {Suspense} from 'react';
import { I18nextProvider } from 'react-i18next';
import PropTypes from 'prop-types';
import i18n from '../../i18n/i18n';

const WebIntlProvider = props => {

  let {
    children,
  } = props;

  return (
    <Suspense fallback={<div></div>} >
      <I18nextProvider i18n={i18n}>
        <div className={`aw-container aw-locale-${i18n.language}`}>
          {children}
        </div>
      </I18nextProvider>
    </Suspense>
  )

};

export default WebIntlProvider;
